export const environmentConfig = {
  enableSentry: false,
  production: true,
  skipAuthentication: false,
};
